var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[(_vm.question.fill_answer)?_c('CkContent',{attrs:{"content":_vm.question.fill_answer.content,"name":"fill-answer"},on:{"getData":_vm.getData}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }